import './SubFooter.scss';

import { Button, Col, Row } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import messages from './messages';
import { selectLocalSettings } from '../../ducks/settings';
import { useIntl } from 'react-intl';
import { useSelector } from 'react-redux';

const SubFooter = () => {
  const intl = useIntl();
  const lang = useSelector(selectLocalSettings);

  const onClick = () => window.scrollTo(0, 0);

  return (
    <div className="bottom-layout">
      <Row>
        <h3>{intl.formatMessage({ ...messages.noAnswerTitle })}</h3>
      </Row>
      <Row>
        <p className="bottom-layout-faqlink">
          {intl.formatMessage({ ...messages.noAnswerTextWithFAQ })}
        </p>
        <p className="bottom-layout-nofaqlink">
          {intl.formatMessage({ ...messages.noAnswerText })}
        </p>
      </Row>
      <Row className="wrapper-btn">
        <Col sm className="bottom-layout-faqlink">
          <Link to={`/${lang}/faq`} tabIndex={-1}>
            <Button onClick={onClick} className="btn-secondary btn-tell">
              {intl.formatMessage({ ...messages.tellMeMore })}
            </Button>
          </Link>
        </Col>
        <Col sm>
          <Link to={`/${lang}/contactus`} tabIndex={-1}>
            <Button onClick={onClick}>
              {intl.formatMessage({ ...messages.sendUsMessageButton })}
            </Button>
          </Link>
        </Col>
      </Row>
    </div>
  );
};
export default SubFooter;
